// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"47d0bd7f","243":"460a8a47","320":"4f759308","411":"d7051c6d","561":"a7200cc9","597":"eb5b9bbd","842":"a93a4341","905":"2bb257f0","977":"5b8a211e"}[chunkId] + ".chunk.js";
};